export interface ArticleContent {
  id: string;
  title: string;
  author: string;
  date: string;
  category: string;
  tags: string[];
  summary: string;
  content: string;
  coverImage: string;
  views: number;
}

export const articles: Record<string, ArticleContent> = {
  v001: {
    id: 'v001',
    title: '春日的私语',
    author: '影评人小枫',
    date: '2026-08-01',
    category: '影评',
    tags: ['爱情', '剧情', '治愈', '电影推荐'],
    summary: '一部温暖治愈的爱情故事，讲述两个年轻人在樱花盛开的季节相遇、相知、相爱的动人旅程。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20spring%20scene%20with%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20soft%20pink%20petals%20drifting%20in%20breeze%2C%20warm%20sunset%20light%2C%20dreamy%20cinematic%20atmosphere%2C%20beautiful%20natural%20landscape&width=1200&height=600&seq=article-cover-001&orientation=landscape',
    views: 128500,
    content: `<h2>一部让人心动的春日恋歌</h2>
<p>在樱花纷飞的季节里，《春日的私语》为我们呈现了一段纯粹而动人的爱情故事。影片由新锐导演小林执导，以其独特的叙事风格和唯美的视觉语言，将一段青涩的恋爱描绘得如诗如画。</p>
<h2>剧情简介</h2>
<p>故事发生在京都的一个小镇上，女主角樱（由新晋演员小野饰演）是一位热爱摄影的大学生。在一次偶然的樱花祭上，她邂逅了来自东京的建筑师直树。两人因为一张意外拍摄的照片而相识，从此展开了一段跨越季节的爱情旅程。</p>
<p>导演用细腻的镜头语言捕捉了樱花从盛开到凋零的全过程，巧妙地隐喻了爱情的美好与短暂。影片的节奏把控恰到好处，既不会让人觉得过于缓慢，也不会显得仓促。</p>
<h2>演员表现</h2>
<p>小野在片中的表现令人惊艳，她将樱的内敛与热情完美融合，每一个眼神都充满了故事。而男主角的扮演者也用内敛的演技，塑造了一个令人信服的都市青年形象。</p>
<h2>视觉美学</h2>
<p>影片的摄影堪称一绝。樱花、古寺、小巷、落日，每一个画面都美得像是精心构图的明信片。导演对色彩的运用尤其出色，温暖的色调贯穿全片，给人一种被春日阳光包围的感觉。</p>
<h2>音乐与氛围</h2>
<p>配乐由知名作曲家操刀，钢琴与弦乐的交织营造出恰到好处的情感氛围。主题曲《樱花雨》更是成为今年最动人的电影歌曲之一。</p>
<h2>总结</h2>
<p>《春日的私语》不仅仅是一部爱情片，更是一首写给青春和美好的散文诗。它告诉我们，爱情最美的样子，就是在对的季节遇见对的人。强烈推荐给所有相信爱情的朋友。</p>`,
  },
  v002: {
    id: 'v002',
    title: '暗夜追踪',
    author: '资深影迷老王',
    date: '2026-08-01',
    category: '影评',
    tags: ['悬疑', '犯罪', '动作', '电影推荐'],
    summary: '顶级犯罪悬疑大片，跟随硬汉警探深入城市最黑暗的角落，揭开一连串离奇案件背后的惊人真相。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20rainy%20city%20street%20at%20night%20with%20neon%20signs%20reflecting%20on%20wet%20asphalt%2C%20mysterious%20atmosphere%2C%20film%20noir%20cinematography%2C%20dramatic%20shadows%2C%20urban%20landscape&width=1200&height=600&seq=article-cover-002&orientation=landscape',
    views: 256300,
    content: `<h2>年度最佳悬疑犯罪片</h2>
<p>《暗夜追踪》无疑是今年最令人惊艳的悬疑犯罪电影。导演用冷峻的镜头语言和紧凑的叙事节奏，打造了一部让人目不转睛的硬汉警匪片。</p>
<h2>剧情解析</h2>
<p>影片以一桩离奇的连环失踪案为引子，将观众带入了一个充满阴谋与危险的地下世界。主角陈警官（实力派演员担纲）在调查过程中，发现自己逐渐被卷入了一个巨大的阴谋之中。</p>
<p>剧本结构精巧，每一个线索都经过精心设计，反转层层递进，直到最后一刻才揭晓真相。这种叙事手法让观众始终保持高度的紧张感和好奇心。</p>
<h2>角色塑造</h2>
<p>陈警官这个角色塑造得极为立体——他不是传统意义上的英雄，而是一个有血有肉、会犯错的普通人。正是这种真实感，让观众能够产生强烈的共鸣。</p>
<h2>视听语言</h2>
<p>影片的摄影风格偏向暗黑写实，大量使用手持镜头和自然光源，营造出强烈的临场感。动作场面的设计同样精彩，每场追逐戏和打斗场景都干净利落、力道十足。</p>
<h2>总结</h2>
<p>《暗夜追踪》是一部制作精良、剧情扎实的犯罪悬疑佳作。它既有商业片的娱乐性，又不失艺术片的深度。如果你喜欢《无间道》这类型的电影，那么这部绝对不容错过。</p>`,
  },
  v004: {
    id: 'v004',
    title: '星际征途：新纪元',
    author: '科幻专栏作家星海',
    date: '2026-08-01',
    category: '影评',
    tags: ['科幻', '冒险', '特效', '电影推荐'],
    summary: '年度最受期待的科幻巨制！人类星际殖民舰队在遥远星系遭遇未知文明。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20vast%20alien%20planet%20landscape%20with%20two%20suns%20setting%2C%20futuristic%20spaceship%20in%20orbit%2C%20colorful%20nebula%20in%20sky%2C%20epic%20sci-fi%20cinematography%2C%20dramatic%20cosmic%20scene&width=1200&height=600&seq=article-cover-004&orientation=landscape',
    views: 421000,
    content: `<h2>中国科幻电影的里程碑</h2>
<p>《星际征途：新纪元》的上映，标志着中国科幻电影进入了一个全新的纪元。这部耗资巨大的科幻巨制，不仅在视觉效果上达到了国际一流水准，更在故事深度上给出了令人惊喜的答卷。</p>
<h2>世界观构建</h2>
<p>影片设定在距今300年后的未来世界，人类已经成功掌握了星际旅行的技术，并在银河系中建立了多个殖民地。然而，当一个探险舰队在猎户座旋臂发现了一个上古文明遗迹后，一切都发生了改变。</p>
<p>导演和编剧团队花了一年时间构建这个宏大的世界观，从外星文明的生物设计到太空飞船的科技逻辑，每一个细节都经过了严谨的推敲。</p>
<h2>视觉效果</h2>
<p>本片的特效由国际顶尖团队打造，总共有超过2000个特效镜头。无论是浩瀚的星空、壮观的太空站，还是形态各异的外星生物，都呈现出了令人叹为观止的视觉奇观。</p>
<h2>人文内核</h2>
<p>《星际征途》最打动人心的地方在于，它并没有停留在简单的视觉奇观层面，而是深入探讨了人类在面对未知文明时的恐惧、好奇与勇气。影片中那句"我们探索宇宙，其实是在探索自己"，道出了整部电影的核心主题。</p>
<h2>总结</h2>
<p>《星际征途：新纪元》是一部真正意义上的中国硬科幻大片，它在商业性与艺术性之间找到了完美的平衡点。无论是科幻爱好者还是普通观众，都能在这部电影中找到属于自己的感动。</p>`,
  },
  v006: {
    id: 'v006',
    title: '灵境传说',
    author: '动漫评论员小A',
    date: '2026-08-01',
    category: '动漫',
    tags: ['奇幻', '仙侠', '国漫', '动漫推荐'],
    summary: '国漫巅峰之作！讲述少年在仙侠世界中修炼成长、斩妖除魔的热血冒险。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Chinese%20landscape%20with%20floating%20temples%20and%20waterfalls%2C%20ancient%20mythical%20atmosphere%2C%20golden%20clouds%2C%20ethereal%20glowing%20elements%2C%20epic%20fantasy%20art%2C%20vibrant%20colors&width=1200&height=600&seq=article-cover-006&orientation=landscape',
    views: 334200,
    content: `<h2>国漫的骄傲</h2>
<p>《灵境传说》的出现，让所有国漫粉丝都为之振奋。这部作品不仅在视觉上达到了前所未有的高度，在故事叙述和文化表达上也展现出了独特的中国魅力。</p>
<h2>故事背景</h2>
<p>故事发生在一个名为"灵境"的仙侠世界，这里灵气充沛，万物有灵。主角林枫本是一个普通山村少年，在一次意外中获得了上古传承，从此踏上了一条充满危险与机遇的修仙之路。</p>
<p>《灵境传说》最令人称道的是其对中国传统文化的深度挖掘。从道家哲学到民间传说，从古代神话到武术精髓，都在作品中得到了精彩的呈现。</p>
<h2>制作水准</h2>
<p>每集的制作预算高达千万级别，从角色设计到场景建模，从动作捕捉到后期渲染，每一个环节都精益求精。特别是战斗场景的呈现，流畅的动作、华丽的特效、精准的镜头调度，让人目不暇接。</p>
<h2>角色魅力</h2>
<p>除了主角林枫的成长线外，配角们的塑造同样精彩。无论是亦正亦邪的白发剑客，还是活泼可爱的精灵少女，每一个角色都有着自己鲜明的个性和完整的故事弧线。</p>
<h2>总结</h2>
<p>《灵境传说》是国产动漫真正走向世界的一个里程碑。它证明了我们不仅能做出顶级品质的动画，更能讲述具有中国文化特色的精彩故事。</p>`,
  },
  v010: {
    id: 'v010',
    title: '笑傲江湖之风云再起',
    author: '武侠文化研究者剑心',
    date: '2026-08-01',
    category: '剧评',
    tags: ['武侠', '古装', '动作', '电视剧推荐'],
    summary: '改编自经典武侠巨著的全新力作！江湖风云变幻，英雄辈出。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20misty%20Chinese%20mountain%20landscape%20with%20ancient%20temples%2C%20pine%20trees%2C%20warriors%20silhouettes%20on%20cliff%20edge%2C%20dramatic%20sunrise%20light%2C%20wuxia%20cinematic%20style%2C%20epic%20atmosphere&width=1200&height=600&seq=article-cover-010&orientation=landscape',
    views: 567800,
    content: `<h2>经典重铸，再创辉煌</h2>
<p>《笑傲江湖之风云再起》是对金庸先生经典武侠巨著的全新演绎。这部剧集在尊重原著精神的基础上，进行了大胆而富有创意的改编，为观众呈现了一个既熟悉又新鲜的武侠世界。</p>
<h2>剧情改编</h2>
<p>新版在保留原著核心情节的同时，对一些支线故事进行了深化和拓展。特别是对几位女性角色的塑造更加丰满立体，让她们不再只是男主角的陪衬，而是有着自己独立人格和追求的人物。</p>
<p>剧集共48集，节奏把控得当，既有激烈的武打场面，也有细腻的感情戏份，文武张弛有度。</p>
<h2>演员阵容</h2>
<p>此次选角堪称豪华，主角团由当下最具人气的实力派演员组成。男主角将令狐冲的洒脱不羁与内心挣扎演绎得入木三分，女主任盈盈更是将角色的聪慧与柔情展现得淋漓尽致。</p>
<h2>制作精良</h2>
<p>剧组走遍了中国多个名胜古迹进行实景拍摄，从西湖的烟雨朦胧到华山的险峻绝壁，每一个场景都美不胜收。服装设计和道具制作也尽显匠心，完美还原了明朝时期的武侠风貌。</p>
<h2>武术设计</h2>
<p>动作指导团队为每个角色都设计了独特的武术风格，独孤九剑的飘逸灵动、吸星大法的诡异霸道，都在屏幕上得到了精彩呈现。每场打戏都是一场视觉盛宴。</p>
<h2>总结</h2>
<p>《笑傲江湖之风云再起》是一部诚意满满的武侠精品，无论你是原著粉丝还是新观众，都能在这部剧中找到属于自己的江湖梦想。</p>`,
  },
};

export const aboutContent = {
  brandIntro: {
    title: '品牌介绍',
    content: `密桃视频成立于2024年，是国内领先的视频内容聚合平台。我们致力于为观众提供一站式的高清视频观看体验，聚合了红桃视频、樱桃视频、茄子视频、糖心视频等多家优质内容平台的资源，让用户无需在多个平台之间切换，即可畅享海量高清影视内容。

我们的团队由一群热爱影视的年轻人组成，他们来自互联网、影视制作、内容运营等不同领域，怀揣着"让每个人都能轻松享受优质影视内容"的使命，不断优化产品体验，丰富内容库。

密桃视频采用先进的视频分发技术，确保用户在观看过程中的流畅体验。无论是热门大片、经典剧集、精彩综艺还是热血动漫，用户都能在密桃视频上找到并享受不卡顿的观看体验。`,
  },
  reputation: {
    title: '口碑评价',
    testimonials: [
      {
        name: '张先生',
        role: '资深影迷',
        content: '密桃视频真的是我最近发现的最好的观影平台！资源太全了，画质也很清晰，而且完全不卡，比我在其他平台上看舒服多了。',
        rating: 5,
      },
      {
        name: '李女士',
        role: '追剧达人',
        content: '作为一个追剧狂魔，密桃视频让我省了好多事。以前要在好几个APP之间切换，现在一个就够了，更新也很快。',
        rating: 5,
      },
      {
        name: '王同学',
        role: '大学生',
        content: '宿舍网络不太好，但密桃视频的加载速度居然还挺快的。分类也很清晰，找片子很方便，强烈推荐给同学们！',
        rating: 4,
      },
      {
        name: '刘女士',
        role: '宝妈',
        content: '晚上孩子睡了之后就是我的追剧时间，密桃视频的片源真的很多，而且基本都是高清的，观影体验很好。',
        rating: 5,
      },
      {
        name: '赵先生',
        role: 'IT从业者',
        content: '从技术角度看，密桃视频的加载速度和视频质量确实做得很不错。界面设计也很简洁直观，用户体验很好。',
        rating: 4,
      },
      {
        name: '陈女士',
        role: '自由职业者',
        content: '种类特别齐全！想看什么类型的都有，而且更新速度很快，新上映的热门影片很快就能在平台上找到。',
        rating: 5,
      },
    ],
  },
  contact: {
    title: '联系我们',
    email: 'contact@mitaovideo.com',
    wechat: 'MitVideo_Official',
    qq: '88886666',
    phone: '400-888-6666',
    address: '北京市朝阳区建国路88号SOHO现代城A座',
    workingHours: '周一至周五 9:00 - 18:00',
  },
};